import { GridCellParams } from '@mui/x-data-grid-pro'
import { cta_linkTextAlert } from 'ext-ui/style/colors'
import React from 'react'
import DataGridCell from 'src/components/DataGrid/cells/DataGridCell/DataGridCell'
import DataGridEditableCell from 'src/components/DataGrid/cells/DataGridEditableCell/DataGridEditableCell'
import { ExpenseDetailsSourceIcon } from 'src/components/ExpenseDetailsSourceIcon/ExpenseDetailsSourceIcon'
import {
  ExpenseCategoryFieldKey,
  TransactionsDataGridRowModel,
} from 'src/components/TransactionsDataGrid/transactionsDataGrid.types'
import { useTranslate } from 'src/localization/Trns'
import { css } from 'styled-components'

interface TransactionExpenseCategoryCellProps {
  params: GridCellParams<TransactionsDataGridRowModel>
  onClear: () => void
  loading?: boolean
  editable?: boolean
}

const TransactionExpenseCategoryCell = ({
  editable = true,
  ...props
}: TransactionExpenseCategoryCellProps): React.ReactElement => {
  const translate = useTranslate()
  const { params, onClear, loading } = props

  // Extract precomputed expense category data from the field key
  const fieldKey: ExpenseCategoryFieldKey =
    params.field as ExpenseCategoryFieldKey
  const ecComputed = params.row.expenseCategoryCellData[fieldKey]

  if (!ecComputed) {
    return <DataGridCell text="" params={params} />
  }

  const {
    valueText,
    showMissingWhenEmpty,
    appliedByAutomation,
    generatedByPrediction = false,
    errorMessage,
    cellType,
  } = ecComputed

  let value: React.ReactNode
  if (showMissingWhenEmpty) {
    value = (
      <span style={{ color: cta_linkTextAlert }}>{translate('Missing')}</span>
    )
  } else if (!valueText) {
    value = ''
  } else {
    value = (
      <span className={'flex-row gap-2 align-center'}>
        {appliedByAutomation && (
          <ExpenseDetailsSourceIcon
            generatedByPrediction={generatedByPrediction}
            errorMessage={errorMessage}
          />
        )}
        <span
          css={css`
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          `}
        >
          {valueText}
        </span>
      </span>
    )
  }

  if (editable) {
    return (
      <DataGridEditableCell
        type={cellType}
        value={value}
        params={params}
        editMode={'cell'}
        onClear={onClear}
        loadingState={loading ? 'pending' : 'idle'}
      />
    )
  }

  return <DataGridCell text={value} params={params} />
}

export default TransactionExpenseCategoryCell
